<template>
  <div class="whiteBg main">
    <div class="flex clockBox">
      <van-icon name="clock" color="#10aeff" />
    </div>
    <div class="title">
      <h2>支付金额</h2>
      <h2>¥{{ formatMoney(info.payAmount) || '0.00' }}</h2>
    </div>
    <van-divider />
    <div class="orderInfo">
      <div class="flex">
        <div class="left">订单号：</div>
        <div>
          {{ info.orderId }}
        </div>
      </div>
      <div class="flex">
        <div class="left">手机号：</div>
        <div>
          {{ info.senderPhone }}
        </div>
      </div>
      <div class="flex">
        <div class="left">下单时间：</div>
        <div>{{ formatTime(info.createTime) }}</div>
      </div>
    </div>
    <van-button class="pay_btn" type="primary" @click="handlePay()"
      >立即支付</van-button
    >
  </div>
</template>
<script>
export default {
  data() {
    return {
      params: null,
      info: {},
      obj: {}
    }
  },
  created() {
    if (this.$route.query) {
      this.params = this.$route.query
      this.getInfo()
    }
  },
  methods: {
    getInfo() {
      this.$api.getUserOrderDetail(this.params).then(res => {
        if (res.code === 0) {
          this.info = res.data
        }
      })
    },
    formatTime(value) {
      return this.$format(value)
    },
    formatMoney(value) {
      let result = parseFloat(value)
      if (isNaN(result)) {
        return false
      }
      result = Math.floor(value * 100) / 100
      let str = result.toString()
      let index = str.indexOf('.')
      if (index < 0) {
        index = str.length
        str += '.'
      }
      while (str.length <= index + 2) {
        str += '0'
      }
      return str
    },
    handlePay() {
      // if (this.$store.state.payInfo) {
      //   this.wxPay(this.$store.state.payInfo)
      // } else {
      let userInfo = JSON.parse(localStorage.getItem('userInfo'))
      let params = {
        ...this.params,
        wechatId: userInfo.partner,
        openId: userInfo.openId,
        tradeType: 1
      }
      const data = this.$Base64.encode(JSON.stringify(params))
      this.$api.wx_prepayment(data).then(res => {
        // this.$store.commit('set_payInfo', res.data)
        this.wxPay(res.data)
      })
      // }
    },
    wxPay(info) {
      let that = this
      global.wx.chooseWXPay({
        timestamp: info.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
        nonceStr: info.nonceStr, // 支付签名随机串，不长于 32 位
        package: info.packages, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
        signType: info.signType, // 微信支付V3的传入RSA,微信支付V2的传入格式与V2统一下单的签名格式保持一致
        paySign: info.paySign, // 支付签名
        success: function(res) {
          // 支付成功后的回调函数
          that.$router.replace('/fee/paySuccess')
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.main {
  position: fixed;
  width: 100vw;
  height: 100vh;
  padding-top: 48px;
  text-align: center;
  .clockBox {
    margin: 0 0 32px;
  }
  .title {
    margin: 0 0 10px;
    h2 {
      margin-bottom: 16px;
    }
  }
  .orderInfo {
    width: 80%;
    margin: 10px auto;
    padding: 5%;
    padding-top: 5px;
    text-align: right;
    .left {
      width: 90px;
    }
    :nth-child(2) {
      flex: 1;
    }
  }
  .pay_btn {
    margin-top: 40px;
    width: 50vw;
    font-size: 17px;
    font-weight: 700;
  }
}
.van-icon {
  font-size: 60px !important;
}
</style>
